/**
 * Phase 6 · D9 · the scenario planner's strings. Spread into `HU` and `EN` in `../catalogue.ts`; a
 * key in one and not the other is a type error there.
 *
 * ⚠️ Vowel harmony: no suffix is ever glued to a placeholder — the count leads, or the sentence is
 * turned so nothing follows it.
 */
export const HU = {
  /* ── the list (`07`) ── */
  'dealScenario.list.label': 'A deal scenariói',
  'dealScenario.search': 'Keresés scenario névre…',
  'dealScenario.action.new': 'Új scenario',
  'dealScenario.action.open': 'Megnyitás',
  'dealScenario.action.duplicate': 'Duplikálás',
  'dealScenario.action.markWinner': 'Nyertessé jelölés',
  'dealScenario.action.unmark': 'Nyertes jelölés levétele',
  'dealScenario.action.delete': 'Scenario törlése',
  'dealScenario.action.rename': 'Átnevezés',
  'dealScenario.action.openPlan': 'Terv megnyitása',
  'dealScenario.action.newLine': 'Sortétel',
  'dealScenario.column.name': 'Scenario',
  'dealScenario.column.kind': 'Típus',
  'dealScenario.column.status': 'Státusz',
  'dealScenario.column.revenue': 'Bevétel',
  'dealScenario.column.cost': 'Terv. költség',
  'dealScenario.column.margin': 'Margó',
  'dealScenario.column.hours': 'Óra',
  'dealScenario.column.span': 'Időzítés',
  'dealScenario.column.createdBy': 'Készítette',
  'dealScenario.kind.one_off': 'Egyszeri',
  'dealScenario.kind.recurring': 'Ismétlődő',
  'dealScenario.status.draft': 'Tervezet',
  'dealScenario.status.sent': 'Beadva',
  'dealScenario.status.won': 'Nyertes',
  'dealScenario.status.dropped': 'Elvetve',
  'dealScenario.tile.count': 'Scenariók',
  'dealScenario.tile.drafts': '{count} tervezet',
  'dealScenario.tile.winner': 'Nyertes',
  'dealScenario.tile.winnerSub': 'ebből lett a terv',
  'dealScenario.tile.noWinner': 'még nincs kijelölve',
  'dealScenario.tile.bestRevenue': 'Legnagyobb bevétel',
  'dealScenario.tile.bestMargin': 'Legjobb margó',
  'dealScenario.footer.count': '{count} scenario',
  'dealScenario.footer.winner': 'nyertes: {name}',
  'dealScenario.footer.noWinner': 'nyertes még nincs — a nyertes kerül át a tervbe',
  'dealScenario.empty.title': 'Nincs scenario',
  'dealScenario.empty.body':
    'A scenario a deal árának és erőforrás-tervének vázlata. Vegyél fel egyet, aztán duplikáld a változatokhoz — a nyertes kerül át a Tervbe.',
  'dealScenario.empty.filtered': 'Egy scenario neve sem illik a keresésre',
  'dealScenario.empty.filteredBody': 'Összesen {count} scenario van, a keresés mindet elrejti.',
  'dealScenario.empty.clear': 'Keresés törlése',
  'dealScenario.copyName': '{name} (másolat)',
  'dealScenario.toast.created': 'Scenario létrehozva',
  'dealScenario.toast.duplicated':
    'Scenario duplikálva — a sortételek, erőforrások és órák együtt jöttek át',
  'dealScenario.toast.deleted': 'Scenario törölve: {name}',
  'dealScenario.toast.unmarked': 'Nyertes jelölés levéve — a terv nem változott',
  'dealScenario.toast.won': 'A nyertes scenario: {name} — a Terv és az Erőforrás frissült',
  'dealScenario.confirm.deleteTitle': 'Törlöd a scenariót?',
  'dealScenario.confirm.deleteBody':
    'A(z) „{name}” scenario minden sortétele, erőforrása, órája és költsége törlődik. A deal terve nem változik.',

  /* ── the comparison (`07d`) ── */
  'dealScenario.compare.show': 'Összehasonlítás',
  'dealScenario.compare.hide': 'Összehasonlítás elrejtése',
  'dealScenario.compare.close': 'Elrejtés',
  'dealScenario.compare.title': 'Összehasonlítás',
  'dealScenario.compare.hint': '{count} scenario egymás mellett — a legjobb érték kiemelve.',
  'dealScenario.compare.metric': 'Mutató',
  'dealScenario.compare.marginPct': 'Margó %',
  'dealScenario.compare.pick': 'Összehasonlításba',
  'dealScenario.compare.pickOne': 'Összehasonlításba: {name}',

  /* ── a new scenario (`07e`) ── */
  'dealScenario.new.title': 'Új scenario',
  'dealScenario.new.hint':
    'Egy változat a deal árára és erőforrás-tervére. Később duplikálhatod és összehasonlíthatod.',
  'dealScenario.new.create': 'Létrehozás',
  'dealScenario.field.name': 'Scenario neve',
  'dealScenario.field.namePlaceholder': 'pl. Alap — teljes scope',
  'dealScenario.field.kind': 'Szerződés típusa',
  'dealScenario.field.start': 'Kezdés',
  'dealScenario.error.name': 'A scenario neve kötelező.',
  'dealScenario.error.start': 'Add meg, mikor indul a scenario.',

  /* ── the editor (`07b`) ── */
  'dealScenario.back': 'Scenariók',
  'dealScenario.menu': 'Scenario műveletek',
  'dealScenario.readOnly.closed':
    'Csak olvasható — a deal le van zárva, a scenariói referenciaként maradnak meg.',
  'dealScenario.readOnly.dropped':
    'Csak olvasható — egy másik scenario nyert, ez a változat referenciaként marad meg.',
  'dealScenario.readOnly.denied': 'Csak olvasható — a deal szerkesztéséhez nincs jogosultságod.',
  'dealScenario.tile.revenue': 'Bevétel',
  'dealScenario.tile.withOptions': 'opciókkal',
  'dealScenario.tile.withoutOptions': 'opciók nélkül',
  'dealScenario.tile.labour': 'Munkaerő-költség',
  'dealScenario.tile.allocated': '{hours} allokáció',
  'dealScenario.tile.external': 'Külső költség',
  'dealScenario.tile.costRows': '{count} sor',
  'dealScenario.tile.margin': 'Margó',
  'dealScenario.tile.marginSub': '{pct} fedezet',
  'dealScenario.tile.hours': 'Összes óra',
  'dealScenario.tile.fte': '{fte} FTE / hó',
  'dealScenario.tile.span': 'Időzítés',
  'dealScenario.tile.months': '{count} hónap',
  'dealScenario.tile.periods': '{count} periódus',
  'dealScenario.tile.perHour': 'Bevétel / óra',
  'dealScenario.tile.perHourSub': 'átlagos árbevétel',
  'dealScenario.tile.noHours': 'nincs allokáció',
  'dealScenario.kind.menu': 'Szerződés típusa',
  'dealScenario.kind.oneOffContract': 'Egyszeri szerződés',
  'dealScenario.kind.recurringContract': 'Ismétlődő szerződés',
  'dealScenario.kind.oneOffHint': 'egy ütem, hónapokra bontott allokáció',
  'dealScenario.kind.recurringHint': 'periódus-sablon + ütem, két lépésben',
  'dealScenario.view.menu': 'Nézet',
  'dealScenario.view.options': 'Opció típusú sortételek',
  'dealScenario.view.withOptions': 'Beszámítva',
  'dealScenario.view.withoutOptions': 'Kihagyva',
  'dealScenario.view.labelWith': 'Óra · opciókkal',
  'dealScenario.view.labelWithout': 'Óra · opciók nélkül',
  'dealScenario.steps.label': 'Ismétlődő scenario lépései',
  'dealScenario.steps.template': 'Periódus-sablon',
  'dealScenario.steps.templateHint': 'egy periódus tartalma',
  'dealScenario.steps.schedule': 'Ütem és indexálás',
  'dealScenario.steps.scheduleHint': '{count} periódus',
  'dealScenario.lines.emptyTitle': 'Nincs sortétel',
  'dealScenario.lines.emptyBody':
    'A sortétel a scenario egy vállalási egysége: bevétel, és alatta az erőforrások órái hónapokra bontva.',
  'dealScenario.winner.title': 'Nyertessé jelölöd?',
  'dealScenario.winner.body': 'A(z) „{name}” scenario átkerül a deal tervébe:',
  'dealScenario.winner.replace':
    'a Terv sortételei, a placeholderek, az órák és a külső költségek helyére a scenario tartalma kerül;',
  'dealScenario.winner.value':
    'a deal értéke a projekttervből számol, a bevételi ütem a scenario típusa lesz;',
  'dealScenario.winner.others': 'a többi scenario Elvetve állapotba kerül, olvashatóan megmarad;',
  'dealScenario.winner.milestones':
    'a mérföldkövek maradnak, a lecserélt sortételek mérföldköve elvész.',
  'dealScenario.winner.confirm': 'Nyertessé jelölés',

  /* ── the grid ── */
  'dealScenario.grid.label': 'A scenario sortételei és erőforrásai',
  'dealScenario.grid.item': 'Sortétel · erőforrás',
  'dealScenario.grid.type': 'Típus',
  'dealScenario.grid.hours': 'Óra',
  'dealScenario.grid.revenue': 'Bevétel',
  'dealScenario.grid.cost': 'Költség',
  'dealScenario.grid.margin': 'Margó',
  'dealScenario.grid.period': 'Egy periódus',
  'dealScenario.grid.template': 'sablon',
  'dealScenario.grid.addMonth': 'Még egy hónap',
  'dealScenario.grid.hint': 'A cellákba fejenkénti óraszámot írsz, Enterrel mentesz.',
  'dealScenario.grid.hintRecurring': 'Egy periódus tartalma — az ütem a 2. lépésben.',
  'dealScenario.drafts': '{count} mentetlen cella',
  'dealScenario.discard': 'Elvetés',
  'dealScenario.cell': '{name} · {line} · {period}',
  'dealScenario.cell.heads': '{hours} fejenként × {count} fő',
  'dealScenario.foot.hours': 'Σ óra',
  'dealScenario.foot.labour': 'Munkaerő-költség',
  'dealScenario.foot.revenue': 'Bevétel',
  'dealScenario.foot.margin': 'Margó',
  'dealScenario.line.newName': 'Új sortétel',
  'dealScenario.line.name': 'Sortétel neve',
  'dealScenario.line.type': 'Típus: {name}',
  'dealScenario.line.amount': 'Bevétel: {name}',
  'dealScenario.line.menu': 'Sortétel műveletek',
  'dealScenario.line.duplicate': 'Duplikálás',
  'dealScenario.line.collapse': 'Erőforrások összecsukása',
  'dealScenario.line.expand': 'Erőforrások kinyitása',
  'dealScenario.line.delete': 'Sortétel törlése',
  'dealScenario.line.optionOff': 'Opció — a nézet most kihagyja az összegekből.',
  'dealScenario.error.lineName': 'A sortétel neve kötelező.',
  'dealScenario.error.hours': 'Az órát így add meg: 8, 8h, 8:00 vagy 8,0.',
  'dealScenario.error.maxHours': 'Egy cellába legfeljebb 2000 óra kerülhet.',
  'dealScenario.confirm.lineTitle': 'Törlöd a sortételt?',
  'dealScenario.confirm.lineBody': 'A(z) „{name}” sortétel és minden órája törlődik.',
  'dealScenario.add.resource': 'Erőforrás',
  'dealScenario.add.to': 'Erőforrás hozzáadása ide: {name}',
  'dealScenario.add.existing': 'A scenario erőforrásai',
  'dealScenario.add.profiles': 'Új placeholder profilból',
  'dealScenario.add.noProfiles': 'Nincs placeholder profil — a Deal beállításokban veheted fel',
  'dealScenario.add.free': 'Szabad szerepkör…',
  'dealScenario.add.search': 'Keresés…',
  'dealScenario.add.empty': 'Nincs találat',
  'dealScenario.add.none': 'Nincs erőforrás allokálva',

  /* ── a resource ── */
  'dealScenario.resource.menu': 'Erőforrás műveletek',
  'dealScenario.resource.rate': '{rate} / óra',
  'dealScenario.resource.heads': '{count} fő',
  'dealScenario.resource.headcount': 'Létszám',
  'dealScenario.resource.headcountLess': 'Létszám csökkentése',
  'dealScenario.resource.headcountMore': 'Létszám növelése',
  'dealScenario.resource.editAction': 'Szerkesztés…',
  'dealScenario.resource.clear': 'Órák törlése ezen a sortételen',
  'dealScenario.resource.detach': 'Eltávolítás a sortételről',
  'dealScenario.resource.delete': 'Erőforrás törlése',
  'dealScenario.resource.new': 'Szabad szerepkör',
  'dealScenario.resource.newHint':
    'Saját névvel és óradíjjal, placeholder profil nélkül — a terv placeholdere lesz belőle.',
  'dealScenario.resource.edit': 'Erőforrás szerkesztése',
  'dealScenario.resource.name': 'Megnevezés',
  'dealScenario.resource.namePlaceholder': 'pl. Senior backend',
  'dealScenario.resource.seniority': 'Szenioritás',
  'dealScenario.resource.noSeniority': '— nincs megadva',
  'dealScenario.resource.rate.label': 'Költség / óra',
  'dealScenario.error.resourceName': 'Az erőforrás neve kötelező.',
  'dealScenario.error.headcount': 'A létszám 1 és 50 közötti egész szám legyen.',
  'dealScenario.confirm.resourceTitle': 'Törlöd az erőforrást?',
  'dealScenario.confirm.resourceBody':
    'A(z) „{name}” erőforrás minden sortételről lekerül, az órái törlődnek.',

  /* ── external costs ── */
  'dealScenario.cost.title': 'Külső költségek',
  'dealScenario.cost.summary': '{amount} · beszámít a margóba',
  'dealScenario.cost.add': 'Költség',
  'dealScenario.cost.empty': 'Nincs külső költség — beszállító, licenc vagy utazás ide jön.',
  'dealScenario.cost.new': 'Új külső költség',
  'dealScenario.cost.edit': 'Külső költség szerkesztése',
  'dealScenario.cost.hint': 'Beszállító, licenc, utazás — a scenario margójából vonódik le.',
  'dealScenario.cost.name': 'Megnevezés',
  'dealScenario.cost.namePlaceholder': 'pl. Terheléstesztelő licenc',
  'dealScenario.cost.amount': 'Összeg',
  'dealScenario.cost.date': 'Dátum',
  'dealScenario.cost.delete': 'Költség törlése',
  'dealScenario.error.costName': 'A költség neve kötelező.',
  'dealScenario.confirm.costTitle': 'Törlöd a költséget?',
  'dealScenario.confirm.costBody': 'A(z) „{name}” külső költség törlődik.',

  /* ── the schedule (`07g`) ── */
  'dealScenario.schedule.label': 'Periódusok',
  'dealScenario.schedule.start': 'Első periódus',
  'dealScenario.schedule.unit': 'Periódus hossza',
  'dealScenario.schedule.count': 'Periódusok száma',
  'dealScenario.schedule.countLess': 'Eggyel kevesebb periódus',
  'dealScenario.schedule.countMore': 'Eggyel több periódus',
  'dealScenario.schedule.index': 'Indexálás / év',
  'dealScenario.schedule.hint':
    'A sablon egy periódusra {revenue} bevételt és {hours} munkát tartalmaz. Az indexálás évente lép, {count} periódusonként; egy periódus bevétele kézzel felülírható.',
  'dealScenario.schedule.period': 'Periódus',
  'dealScenario.schedule.labour': 'Munkaerő',
  'dealScenario.schedule.change': 'Eltérés',
  'dealScenario.schedule.manual': 'kézi',
  'dealScenario.schedule.reset': 'Vissza az indexált értékre',
  'dealScenario.schedule.resetOf': 'Vissza az indexált értékre: {period}',
  'dealScenario.schedule.revenueOf': 'Bevétel: {period}',
  'dealScenario.schedule.total': 'Összesen',
  'dealScenario.schedule.external': 'a margóban {amount} külső költség',
  'dealScenario.error.periodCount': 'A periódusok száma 1 és 120 közötti egész szám legyen.',
  'dealScenario.error.index': 'Az indexálás −50 és 100 közötti százalék legyen.',
  'dealScenario.unit.month': 'Hónap',
  'dealScenario.unit.quarter': 'Negyedév',
  'dealScenario.unit.year': 'Év',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  /* ── the list (`07`) ── */
  'dealScenario.list.label': "The deal's scenarios",
  'dealScenario.search': 'Search by scenario name…',
  'dealScenario.action.new': 'New scenario',
  'dealScenario.action.open': 'Open',
  'dealScenario.action.duplicate': 'Duplicate',
  'dealScenario.action.markWinner': 'Mark as winner',
  'dealScenario.action.unmark': 'Unmark winner',
  'dealScenario.action.delete': 'Delete scenario',
  'dealScenario.action.rename': 'Rename',
  'dealScenario.action.openPlan': 'Open the plan',
  'dealScenario.action.newLine': 'Line item',
  'dealScenario.column.name': 'Scenario',
  'dealScenario.column.kind': 'Type',
  'dealScenario.column.status': 'Status',
  'dealScenario.column.revenue': 'Revenue',
  'dealScenario.column.cost': 'Planned cost',
  'dealScenario.column.margin': 'Margin',
  'dealScenario.column.hours': 'Hours',
  'dealScenario.column.span': 'Timing',
  'dealScenario.column.createdBy': 'Created by',
  'dealScenario.kind.one_off': 'One-off',
  'dealScenario.kind.recurring': 'Recurring',
  'dealScenario.status.draft': 'Draft',
  'dealScenario.status.sent': 'Submitted',
  'dealScenario.status.won': 'Winner',
  'dealScenario.status.dropped': 'Dropped',
  'dealScenario.tile.count': 'Scenarios',
  'dealScenario.tile.drafts': '{count} drafts',
  'dealScenario.tile.winner': 'Winner',
  'dealScenario.tile.winnerSub': 'the plan was made from it',
  'dealScenario.tile.noWinner': 'none marked yet',
  'dealScenario.tile.bestRevenue': 'Highest revenue',
  'dealScenario.tile.bestMargin': 'Best margin',
  'dealScenario.footer.count': '{count} scenarios',
  'dealScenario.footer.winner': 'winner: {name}',
  'dealScenario.footer.noWinner': 'no winner yet — the winner is copied into the plan',
  'dealScenario.empty.title': 'No scenarios',
  'dealScenario.empty.body':
    "A scenario sketches the deal's price and staffing. Add one, then duplicate it for the variants — the winner is copied into the Plan.",
  'dealScenario.empty.filtered': 'No scenario name matches the search',
  'dealScenario.empty.filteredBody': 'There are {count} scenarios; the search hides all of them.',
  'dealScenario.empty.clear': 'Clear search',
  'dealScenario.copyName': '{name} (copy)',
  'dealScenario.toast.created': 'Scenario created',
  'dealScenario.toast.duplicated':
    'Scenario duplicated — its line items, resources and hours came with it',
  'dealScenario.toast.deleted': 'Scenario deleted: {name}',
  'dealScenario.toast.unmarked': 'Winner unmarked — the plan is unchanged',
  'dealScenario.toast.won': 'The winning scenario: {name} — Plan and Resources updated',
  'dealScenario.confirm.deleteTitle': 'Delete the scenario?',
  'dealScenario.confirm.deleteBody':
    "Every line item, resource, hour and cost of “{name}” is deleted. The deal's plan does not change.",

  /* ── the comparison (`07d`) ── */
  'dealScenario.compare.show': 'Compare',
  'dealScenario.compare.hide': 'Hide comparison',
  'dealScenario.compare.close': 'Hide',
  'dealScenario.compare.title': 'Comparison',
  'dealScenario.compare.hint': '{count} scenarios side by side — the best value highlighted.',
  'dealScenario.compare.metric': 'Metric',
  'dealScenario.compare.marginPct': 'Margin %',
  'dealScenario.compare.pick': 'Compare',
  'dealScenario.compare.pickOne': 'Compare: {name}',

  /* ── a new scenario (`07e`) ── */
  'dealScenario.new.title': 'New scenario',
  'dealScenario.new.hint':
    "A variant of the deal's price and staffing. You can duplicate and compare it later.",
  'dealScenario.new.create': 'Create',
  'dealScenario.field.name': 'Scenario name',
  'dealScenario.field.namePlaceholder': 'e.g. Base — full scope',
  'dealScenario.field.kind': 'Contract type',
  'dealScenario.field.start': 'Start',
  'dealScenario.error.name': 'The scenario needs a name.',
  'dealScenario.error.start': 'Say when the scenario starts.',

  /* ── the editor (`07b`) ── */
  'dealScenario.back': 'Scenarios',
  'dealScenario.menu': 'Scenario actions',
  'dealScenario.readOnly.closed':
    'Read-only — the deal is closed; its scenarios are kept for reference.',
  'dealScenario.readOnly.dropped':
    'Read-only — another scenario won; this variant is kept for reference.',
  'dealScenario.readOnly.denied': "Read-only — you don't have permission to edit this deal.",
  'dealScenario.tile.revenue': 'Revenue',
  'dealScenario.tile.withOptions': 'with options',
  'dealScenario.tile.withoutOptions': 'without options',
  'dealScenario.tile.labour': 'Labour cost',
  'dealScenario.tile.allocated': '{hours} allocated',
  'dealScenario.tile.external': 'External cost',
  'dealScenario.tile.costRows': '{count} rows',
  'dealScenario.tile.margin': 'Margin',
  'dealScenario.tile.marginSub': '{pct} margin',
  'dealScenario.tile.hours': 'Total hours',
  'dealScenario.tile.fte': '{fte} FTE / month',
  'dealScenario.tile.span': 'Timing',
  'dealScenario.tile.months': '{count} months',
  'dealScenario.tile.periods': '{count} periods',
  'dealScenario.tile.perHour': 'Revenue / hour',
  'dealScenario.tile.perHourSub': 'average rate',
  'dealScenario.tile.noHours': 'nothing allocated',
  'dealScenario.kind.menu': 'Contract type',
  'dealScenario.kind.oneOffContract': 'One-off contract',
  'dealScenario.kind.recurringContract': 'Recurring contract',
  'dealScenario.kind.oneOffHint': 'one schedule, hours by month',
  'dealScenario.kind.recurringHint': 'period template + schedule, in two steps',
  'dealScenario.view.menu': 'View',
  'dealScenario.view.options': 'Option line items',
  'dealScenario.view.withOptions': 'Counted',
  'dealScenario.view.withoutOptions': 'Left out',
  'dealScenario.view.labelWith': 'Hours · with options',
  'dealScenario.view.labelWithout': 'Hours · without options',
  'dealScenario.steps.label': "A recurring scenario's steps",
  'dealScenario.steps.template': 'Period template',
  'dealScenario.steps.templateHint': 'what one period holds',
  'dealScenario.steps.schedule': 'Schedule and indexation',
  'dealScenario.steps.scheduleHint': '{count} periods',
  'dealScenario.lines.emptyTitle': 'No line items',
  'dealScenario.lines.emptyBody':
    "A line item is one unit of the scenario's work: its revenue, and under it the resources' hours by month.",
  'dealScenario.winner.title': 'Mark as winner?',
  'dealScenario.winner.body': "“{name}” is copied into the deal's plan:",
  'dealScenario.winner.replace':
    "the Plan's line items, placeholders, hours and external costs are replaced by the scenario's;",
  'dealScenario.winner.value':
    "the deal's value is taken from the plan, and its revenue mode becomes the scenario's type;",
  'dealScenario.winner.others': 'the other scenarios become Dropped and stay readable;',
  'dealScenario.winner.milestones': 'milestones are kept; the replaced line items lose theirs.',
  'dealScenario.winner.confirm': 'Mark as winner',

  /* ── the grid ── */
  'dealScenario.grid.label': "The scenario's line items and resources",
  'dealScenario.grid.item': 'Line item · resource',
  'dealScenario.grid.type': 'Type',
  'dealScenario.grid.hours': 'Hours',
  'dealScenario.grid.revenue': 'Revenue',
  'dealScenario.grid.cost': 'Cost',
  'dealScenario.grid.margin': 'Margin',
  'dealScenario.grid.period': 'One period',
  'dealScenario.grid.template': 'template',
  'dealScenario.grid.addMonth': 'One more month',
  'dealScenario.grid.hint': 'Type hours per head into the cells; Enter saves.',
  'dealScenario.grid.hintRecurring': 'What one period holds — the schedule is step 2.',
  'dealScenario.drafts': '{count} unsaved cells',
  'dealScenario.discard': 'Discard',
  'dealScenario.cell': '{name} · {line} · {period}',
  'dealScenario.cell.heads': '{hours} per head × {count} people',
  'dealScenario.foot.hours': 'Σ hours',
  'dealScenario.foot.labour': 'Labour cost',
  'dealScenario.foot.revenue': 'Revenue',
  'dealScenario.foot.margin': 'Margin',
  'dealScenario.line.newName': 'New line item',
  'dealScenario.line.name': 'Line item name',
  'dealScenario.line.type': 'Type: {name}',
  'dealScenario.line.amount': 'Revenue: {name}',
  'dealScenario.line.menu': 'Line item actions',
  'dealScenario.line.duplicate': 'Duplicate',
  'dealScenario.line.collapse': 'Collapse resources',
  'dealScenario.line.expand': 'Expand resources',
  'dealScenario.line.delete': 'Delete line item',
  'dealScenario.line.optionOff': 'An option — the view leaves it out of the totals.',
  'dealScenario.error.lineName': 'The line item needs a name.',
  'dealScenario.error.hours': 'Type hours as 8, 8h, 8:00 or 8.0.',
  'dealScenario.error.maxHours': 'A cell holds at most 2000 hours.',
  'dealScenario.confirm.lineTitle': 'Delete the line item?',
  'dealScenario.confirm.lineBody': '“{name}” and every hour on it are deleted.',
  'dealScenario.add.resource': 'Resource',
  'dealScenario.add.to': 'Add a resource to {name}',
  'dealScenario.add.existing': "The scenario's resources",
  'dealScenario.add.profiles': 'New from a placeholder profile',
  'dealScenario.add.noProfiles': 'No placeholder profiles — add them in Deal settings',
  'dealScenario.add.free': 'Free role…',
  'dealScenario.add.search': 'Search…',
  'dealScenario.add.empty': 'No matches',
  'dealScenario.add.none': 'No resources allocated',

  /* ── a resource ── */
  'dealScenario.resource.menu': 'Resource actions',
  'dealScenario.resource.rate': '{rate} / hour',
  'dealScenario.resource.heads': '{count} people',
  'dealScenario.resource.headcount': 'Headcount',
  'dealScenario.resource.headcountLess': 'Decrease headcount',
  'dealScenario.resource.headcountMore': 'Increase headcount',
  'dealScenario.resource.editAction': 'Edit…',
  'dealScenario.resource.clear': 'Clear the hours on this line item',
  'dealScenario.resource.detach': 'Remove from the line item',
  'dealScenario.resource.delete': 'Delete resource',
  'dealScenario.resource.new': 'Free role',
  'dealScenario.resource.newHint':
    'With its own name and hourly cost, no placeholder profile — it becomes a placeholder in the plan.',
  'dealScenario.resource.edit': 'Edit resource',
  'dealScenario.resource.name': 'Name',
  'dealScenario.resource.namePlaceholder': 'e.g. Senior backend',
  'dealScenario.resource.seniority': 'Seniority',
  'dealScenario.resource.noSeniority': '— not set',
  'dealScenario.resource.rate.label': 'Cost / hour',
  'dealScenario.error.resourceName': 'The resource needs a name.',
  'dealScenario.error.headcount': 'Headcount is a whole number from 1 to 50.',
  'dealScenario.confirm.resourceTitle': 'Delete the resource?',
  'dealScenario.confirm.resourceBody': '“{name}” leaves every line item and its hours are deleted.',

  /* ── external costs ── */
  'dealScenario.cost.title': 'External costs',
  'dealScenario.cost.summary': '{amount} · counted against the margin',
  'dealScenario.cost.add': 'Cost',
  'dealScenario.cost.empty': 'No external costs — suppliers, licences or travel go here.',
  'dealScenario.cost.new': 'New external cost',
  'dealScenario.cost.edit': 'Edit external cost',
  'dealScenario.cost.hint': "Suppliers, licences, travel — subtracted from the scenario's margin.",
  'dealScenario.cost.name': 'Name',
  'dealScenario.cost.namePlaceholder': 'e.g. Load-testing licence',
  'dealScenario.cost.amount': 'Amount',
  'dealScenario.cost.date': 'Date',
  'dealScenario.cost.delete': 'Delete cost',
  'dealScenario.error.costName': 'The cost needs a name.',
  'dealScenario.confirm.costTitle': 'Delete the cost?',
  'dealScenario.confirm.costBody': 'The external cost “{name}” is deleted.',

  /* ── the schedule (`07g`) ── */
  'dealScenario.schedule.label': 'Periods',
  'dealScenario.schedule.start': 'First period',
  'dealScenario.schedule.unit': 'Period length',
  'dealScenario.schedule.count': 'Number of periods',
  'dealScenario.schedule.countLess': 'One period fewer',
  'dealScenario.schedule.countMore': 'One period more',
  'dealScenario.schedule.index': 'Indexation / year',
  'dealScenario.schedule.hint':
    "The template holds {revenue} of revenue and {hours} of work per period. Indexation applies yearly, every {count} periods; any period's revenue can be typed over.",
  'dealScenario.schedule.period': 'Period',
  'dealScenario.schedule.labour': 'Labour',
  'dealScenario.schedule.change': 'Change',
  'dealScenario.schedule.manual': 'manual',
  'dealScenario.schedule.reset': 'Back to the indexed figure',
  'dealScenario.schedule.resetOf': 'Back to the indexed figure: {period}',
  'dealScenario.schedule.revenueOf': 'Revenue: {period}',
  'dealScenario.schedule.total': 'Total',
  'dealScenario.schedule.external': '{amount} of external cost in the margin',
  'dealScenario.error.periodCount': 'The number of periods is a whole number from 1 to 120.',
  'dealScenario.error.index': 'Indexation is a percentage from −50 to 100.',
  'dealScenario.unit.month': 'Month',
  'dealScenario.unit.quarter': 'Quarter',
  'dealScenario.unit.year': 'Year',
};
